<template>
  <v-dialog v-model="dialog" scrollable max-width="70%" persistent>
    <v-card>
      <v-card-title>
        <v-row class="ma-0 pa-0">
          <v-spacer></v-spacer>
          <v-btn icon dark @click="close()">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
          <v-col class="pt-0 pb-0 text-center" cols="12">
            <h1>Anexar arquivos {{emMassa?"em massa":""}} {{ tituloPorTipo[tipoConsulta] }}</h1>
            <span style="font-size:16px;font-weight:normal" v-if="emMassa">Total de {{total}} de {{tipoConsulta}} {{tipoConsulta=='guias'?'selecionada(s)':'selecionado(s)'}}</span>
            <span style="font-size:16px;font-weight:normal" v-else-if="tipoConsulta=='guias'">{{itemSelecionado.nome_beneficiario}}</span>
            <span style="font-size:16px;font-weight:normal" v-else-if="tipoConsulta=='itens'">{{itemSelecionado.descricao_procedimento}}</span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <template v-if="!emMassa">
        <v-row  wrap class="mx-0 my-5 pt-5"  v-if="tipoConsulta=='lotes'" >
          <v-col class="text-left pb-2">
            <span class="card-title-form-guia textsRec" style="display: block">Núm. do lote:</span>
            <span style="font-size:16px;font-weight:normal">{{itemSelecionado.numero_lote}}</span>
          </v-col>
          <v-col class="text-left pb-2 pt-0">
            <span class="card-title-form-guia textsRec" style="display: block">Ident. prestador:</span>
            <span style="font-size:16px;font-weight:normal">{{itemSelecionado.identificador_prestador}}</span>
          </v-col>
          <v-col class="text-left pb-2 pt-0">
            <span class="card-title-form-guia textsRec" style="display: block">Protocolo recursado: </span>
            <span style="font-size:16px;font-weight:normal">{{itemSelecionado.protocolo_recursado}}</span>
          </v-col>
          <v-col class="text-left pb-2 pt-0">
            <span class="card-title-form-guia textsRec" style="display: block">Núm. guia do recurso: </span>
            <span style="font-size:16px;font-weight:normal; color: error">{{ itemSelecionado.numero_guia_recurso}}</span>
          </v-col>
          <v-col class="text-left pb-2 pt-0">
            <span class="card-title-form-guia textsRec" style="display: block">Valor do recurso: </span>
            <span style="font-size:16px;font-weight:normal; color: error">{{ itemSelecionado.valor_recursado | formatPrice }}</span>
          </v-col>
        </v-row>
        <v-row  wrap class="mx-0 my-5 pt-5" v-else-if="tipoConsulta=='guias'">
          <v-col class="text-left pb-2 pt-0">
            <span class="card-title-form-guia textsRec" style="display: block">Ident. prestador:</span>
            <span style="font-size:16px;font-weight:normal">{{itemSelecionado.identificador_prestador_captura}}</span>
          </v-col>
          <v-col class="text-left pb-2 pt-0">
            <span class="card-title-form-guia textsRec" style="display: block">Núm. lote:</span>
            <span style="font-size:16px;font-weight:normal">{{itemSelecionado.numero_lote}}</span>
          </v-col>
          <v-col class="text-left pb-2 pt-0">
            <span class="card-title-form-guia textsRec" style="display: block">Núm. guia prestador: </span>
            <span style="font-size:16px;font-weight:normal">{{itemSelecionado.numero_guia_prestador}}</span>
          </v-col>
          <v-col class="text-left pb-2 pt-0">
            <span class="card-title-form-guia textsRec" style="display: block">Núm. carteirinha: </span>
            <span style="font-size:16px;font-weight:normal; color: error">{{ itemSelecionado.carteira_beneficiario}}</span>
          </v-col>
          <v-col class="text-left pb-2 pt-0">
            <span class="card-title-form-guia textsRec" style="display: block">Valor do recurso: </span>
            <span style="font-size:16px;font-weight:normal; color: error">{{ itemSelecionado.valor_recursado | formatPrice }}</span>
          </v-col>
        </v-row>
        <v-row  wrap class="mx-0 my-5 pt-5" v-else-if="tipoConsulta=='itens'">
          <v-col class="text-left pb-2 pt-0">
            <span class="card-title-form-guia textsRec" style="display: block">Ident. prestador:</span>
            <span style="font-size:16px;font-weight:normal">{{itemSelecionado.identificador_prestador_captura}}</span>
          </v-col>
          <v-col class="text-left pb-2 pt-0">
            
            <span class="card-title-form-guia textsRec" style="display: block">Núm. lote:</span>
            <span style="font-size:16px;font-weight:normal">{{this.num_lote}}</span>
          </v-col>
          <v-col class="text-left pb-2 pt-0">
            <span class="card-title-form-guia textsRec" style="display: block">Núm. guia prestador: </span>
            <span style="font-size:16px;font-weight:normal">{{itemSelecionado.numero_guia_prestador}}</span>
          </v-col>
          <v-col class="text-left pb-2 pt-0">
            <span class="card-title-form-guia textsRec" style="display: block">Data execução: </span>
            <span style="font-size:16px;font-weight:normal; color: error">{{ itemSelecionado.data_execucao | formatDate}}</span>
          </v-col>
          <v-col class="text-left pb-2 pt-0">
            <span class="card-title-form-guia textsRec" style="display: block">Valor do recurso: </span>
            <span style="font-size:16px;font-weight:normal; color: error">{{ itemSelecionado.valor_recursado | formatPrice }}</span>
          </v-col>
        </v-row>
        </template>
        <v-row>
          <v-col class="pr-0 pl-5" :cols="emMassa?12:7">
            <v-row>
              <v-col class="px-0" cols="12">
                <v-form ref="anexos_tipo">
                  <v-row class="px-0" v-for="(item, ind) in listaDeAnexos" :key="ind">

                    <v-col class="px-2" cols="5">
                      <label>Tipo de arquivo</label>
                      <v-select
                        v-model="item.tipo"
                        :menu-props="{ bottom: true, offsetY: true }"
                        flat
                        solo
                        dense
                        :items="tiposEnvio"
                        item-text="tipo"
                        item-value="id"
                        outlined
                        :placeholder="'Selecione'"
                        :rules="formRules.required"
                        ></v-select>
                    </v-col>
                    <v-col class="px-2" cols="5">
                      <label>Anexo</label>
                      <v-file-input 
                        :placeholder="'Selecione'"
                        outlined
                        v-model="item.anexo"
                        single-line
                        dense
                        :prepend-icon="null"
                        :background-color="item.error ? '#ee6d6d' : undefined"
                        append-icon="fa-upload"
                        :rules="[ 
                                  item.anexo != null ? item.error ? 'Erro ao salvar arquivo' : true : true,
                                  parametrosAnexo.extensoes.filter(ele => ele.toLowerCase() == item.exte.toLowerCase()).length > 0 ? true : 'Formato de arquivo não aceito', 
                                  item.anexo != null ? item.anexo.size / 1024 > parametrosAnexo.tamanho_maximo ? `Tamanho maximo de ${parametrosAnexo.tamanho_maximo} KB` : true : true, 
                                  item.anexo != null ? item.anexo.name.length > parametrosAnexo.max_nome_arquivo ? `Esta operadora só aceita nome de arquivos com até ${parametrosAnexo.max_nome_arquivo - 4} caracteres` : true : true,
                                  item.anexo != null ? item.anexo.name.substring(0,item.anexo.name.lastIndexOf('.')).length > item.anexo.name.substring(0,item.anexo.name.lastIndexOf('.')).match(/[A-Za-z0-9._-\s]/gi).length ? 'Nome contém caracteres especiais, permitido apenas letras sem acento, números, e espaços' : true : true
                                ]"
                        @click:clear="popItem(ind)"
                        @change="verificaExtensao(ind)"
                      ></v-file-input>
                    </v-col>
<v-col class="px-2" cols="5" v-if="anexo_tiss">
            <label>Tipo de documento</label>
            <v-select
              v-model="item.tipo_documento"
              :menu-props="{ bottom: true, offsetY: true }"
              flat
              solo
              dense
              :items="tipoDocumentoTISS"
              item-text="tipo"
              item-value="id"
              outlined
              :placeholder="'Selecione'"
              :rules="formRules.required"
              ></v-select>
          </v-col>
          <v-col class="px-2" cols="5" v-if="anexo_tiss">
            <label>Formato de documento</label>
            <v-select
              v-model="item.formato_documento"
              :menu-props="{ bottom: true, offsetY: true }"
              flat
              solo
              dense
              :items="formatoDocumentoTISS"
              item-text="tipo"
              item-value="id"
              outlined
              :placeholder="'Selecione'"
              :rules="formRules.required"
              ></v-select>
          </v-col>
                    
                    <v-col class="px-2" cols="10" v-if="anexo_tiss">
           <label>Observação</label>
            <v-textarea
              outlined
              no-resize
              v-model ="item.observacao"      
              :rules="[formRules.max500]"
            ></v-textarea>
          </v-col>
                    <v-col class="pr-2 pl-2 pt-5" cols="2">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn small icon @click="addItemForm()" v-bind="attrs" v-on="on" v-show="listaDeAnexos.length - 1 == ind" :disabled="verificaDisableAdd(ind)">
                            <v-icon color="primary" size="20px">fa-plus</v-icon>
                          </v-btn>
                        </template>
                        <span class="px-3 py-2 ma-0"
                          style="
                            border: solid 1px #999;
                            border-radius: 5px;
                            background-color: #fff;
                        ">Adicionar</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          
                          <v-btn small icon @click="popItem(ind)" v-bind="attrs" v-on="on" v-show="true" :disabled="listaDeAnexos.length == 1">
                            <v-icon color="primary" size="20px">fa-minus</v-icon>
                          </v-btn> 
                        
                        </template>
                        <span class="px-3 py-2 ma-0"
                          style="
                            border: solid 1px #999;
                            border-radius: 5px;
                            background-color: #fff;
                        ">Retirar</span>
                      </v-tooltip>
                    </v-col> 
                  </v-row>
                </v-form>
              </v-col>
            </v-row>

          </v-col>

          <v-col class="pl-0 pr-2 pt-12" cols="5" v-if="!emMassa">
            <v-row v-for="(item, ind) in listaArquivos" :key="item.id">
                <v-col class="px-2 py-0" cols="1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="py-0" small v-if="item.tipo_anexo == 1" color="primary" v-bind="attrs" v-on="on">fa-pills</v-icon>
                      <v-icon class="py-0" small v-if="item.tipo_anexo == 2" color="primary" v-bind="attrs" v-on="on">fa-user-md</v-icon>
                    </template>
                      <span class="px-3 py-2"
                        style="
                          border: solid 1px #999;
                          border-radius: 5px;
                          background-color: #fff;
                      ">{{ tiposEnvio[item.tipo_anexo].tipo }}</span>
                  </v-tooltip>
                </v-col>
              
              <v-col class="px-2 py-1 text-left" cols="9">
                <b>{{ item.nome.toUpperCase().slice(0, 32) }}</b>
              </v-col>

              <v-col class="px-2 py-0 text-right" cols="2">
                <v-spacer />
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">                
                    <v-btn icon x-small @click="download(item)" v-bind="attrs" v-on="on">
                      <v-icon x-small color="primary">fa fa-download</v-icon>
                    </v-btn>
                  </template>
                  <span class="px-3 py-2"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    ">Download
                  </span>
                </v-tooltip>
                <v-tooltip bottom v-if="!emMassa">
                  <template v-slot:activator="{ on, attrs }">                
                    <v-btn icon x-small @click="confirmarExclusao(item)" v-bind="attrs" v-on="on">
                      <v-icon x-small color="primary">fa-trash-alt</v-icon>
                    </v-btn>
                  </template>
                  <span class="px-3 py-2"
                    style="
                      border: solid 1px #999;
                      border-radius: 5px;
                      background-color: #fff;
                    ">Excluir
                  </span>
                </v-tooltip>

              </v-col>

              <v-col class="pa-0 py-2" cols="12" v-if="ind < listaArquivos.length - 1">
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="ma-0">
          <v-btn
          color="primary"
          max-width="100%"
          height="30px"
          small
          depressed
          class="px-5"
          :disabled="listaArquivos.length >= parametrosAnexo.qtde_maxima  || listaDeAnexos.length > (parametrosAnexo.qtde_maxima  - listaArquivos.length) || anexoVazio() || verificaRegras()"
          @click="confirmEnviarArquivos()" 
          >Salvar
          </v-btn><!--  enviarArquivos()  -->
        </v-row>
        <v-row class="ma-0 text-center">
          <v-card-text v-if="this.listaArquivos.length == this.parametrosAnexo.qtde_maxima " style="font-size: 14px; color: red;">
            Máximo de arquivos atingido
          </v-card-text>

          <v-card-text v-else-if="this.listaArquivos.length == 0" style="font-size: 14px; color: black;">
            Nenhum arquivo adicionado
          </v-card-text>

          <v-card-text v-else style="font-size: 14px; color: black;">
            Total de {{ this.listaArquivos.length }} {{ this.listaArquivos.length == 1 ? "arquivo" : "arquivos" }} do máximo de {{ this.parametrosAnexo.qtde_maxima  }}
          </v-card-text>
        </v-row>
      
      </v-card-text>
      <!-- <v-card-actions>
          <v-btn depressed color="primary" @click="close()">
                FECHAR
              </v-btn>
        </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
  components: {
    
  },
  data() {
    return {
      dadosEdicaoMassa:[],
      tituloPorTipo: {
        lotes: "ao(s) lote(s)",
        guias: "à(s) guia(s)",
        itens: "ao(s) item(ns)",
      },
      listaDeAnexos: [{ tipo: null, anexo: null, exte: '.pdf' }],
      formatoDocumentoTISS: [
        {id:null, tipo:"Selecione"},
        {id:"01", tipo:"JPG ou JPEG"},
        {id:"02", tipo:"PDF"},
        {id:"03", tipo:"PNG"},
        {id:"04", tipo:"TIFF"},
        {id:"05", tipo:"CADES - JPG ou JPEG"},
        {id:"06", tipo:"CADES PDF"},
        {id:"07", tipo:"CADES PNG"},
        {id:"08", tipo:"CADES TIFF"},
        {id:"09", tipo:"PADES"}
      ],
      tipoDocumentoTISS: [
        {id:null, tipo:"Selecione"},
        {id:"01", tipo:"Comprovante de elegibilidade"},
        {id:"02", tipo:"Laudo do profissional de saúde"},
        {id:"03", tipo:"Pedido do profissional de saúde"},
        {id:"04", tipo:"Relatório do profissional de saúde"},
        {id:"05", tipo:"Prescrição do profissional de saúde"},
        {id:"06", tipo:"Comprovante de comparecimento (assinatura)"},
        {id:"07", tipo:"Embalagem/rótulo de materiais e/ou medicamentos"},
        {id:"08", tipo:"Comprovante de entrega de medicamentos"},
        {id:"09", tipo:"Notas fiscais"},
        {id:"10", tipo:"Boletim anestésico"},
        {id:"11", tipo:"Selos hemoterápicos"},
        {id:"12", tipo:"Exames de imagem"},
        {id:"13", tipo:"Exames de análises clínicas"},
        {id:"14", tipo:"Termo de consentimento"},
        {id:"15", tipo:"Guia de cobrança de taxa"},
        {id:"16", tipo:"Autorização prévia"},
        {id:"17", tipo:"Relatório de Auditoria"}
      ],
      tiposEnvio: [
        {id: null, tipo: 'Selecione'},
        {id: 1, tipo: 'Materiais - Medicamentos'},
        {id: 2, tipo: 'Procedimentos'}
      ],
      formData: {
            id: null,
            anexo: null
      },
      resEnvio: true,
      parametrosAnexo: {
        extensoes: [".pdf", ".xlsx", ".png", ".jpg", ".gif", ".txt"],
        qtde_maxima: 5,
        tamanho_maximo: 5 * 1024,
        max_nome_arquivo: 50
      },
      anexo_tiss: false
    }
  },
  watch: {
    dialog() {
      this.listaDeAnexos = [{ tipo: null, anexo: null, exte: '.pdf' }]
      this.resEnvio = true
      if(this.parametros && this.parametros.RG_ENVIO_ANEXO && this.parametros.RG_ANEXO_PARAM){
          this.parametrosAnexo = Object.assign(this.parametrosAnexo, JSON.parse(this.parametros.RG_ANEXO_PARAM))
          this.parametrosAnexo.extensoes = JSON.parse(this.parametrosAnexo.extensoes)
          this.parametrosAnexo.max_nome_arquivo == undefined ? this.parametrosAnexo.max_nome_arquivo = 50 : null    
      }
      if(this.parametros && this.parametros.RG_ANEXO_TISS) {
        this.anexo_tiss = this.parametros.RG_ANEXO_TISS
      }
    }
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules
    }),
  },
  mounted() {
  },
  
  methods: {
    ...mapActions({
      getDocument: "documents/getDocument"
    }),
    verificaDisableAdd(ind){
      return this.listaDeAnexos.length >= this.parametrosAnexo.qtde_maxima  || this.listaDeAnexos[ind].anexo == null || /*this.listaDeAnexos[ind].tipo == null ||*/ this.listaDeAnexos.length >= (this.parametrosAnexo.qtde_maxima  - this.listaArquivos.length) 
    },
    popItem(indice, ext){
      if(this.listaDeAnexos.length > 1){
        this.listaDeAnexos.splice(indice, 1)
      }
      else if(ext && this.listaDeAnexos.length == 1){
        this.listaDeAnexos[indice].anexo = undefined
      }
      else if(this.listaDeAnexos.length == 1){        
        this.listaDeAnexos[0].error = false
        this.listaDeAnexos[0].exte = '.pdf'        
      }
    },
    anexoVazio(){
      let resp = this.listaDeAnexos.filter((elemento) => {
        return elemento.anexo == (null || undefined) //|| elemento.tipo == (null || undefined)
      })
      return resp.length ? true : false
    },
    addItemForm() { 
      let tipo, anexo, 
      opts = { tipo, anexo, exte: '.pdf' }
      this.listaDeAnexos.push(opts)

    },
    download(item){
      this.getDocument(item)
    },
    confirmarExclusao(item){
      let paramModal = {
        type: "warning",
        title: "EXCLUIR ARQUIVO!",
        message: 'Não será possivel desfazer essa operação',
        callback: () => this.excluir(item),
        btConfirm: { name: "confirmar", show: true, },
        btCancel: { name: 'Cancelar', show: true }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
    },
    excluir(item){
      let {data_pagamento, prestador_id, operadora_ans_id} =  this.dadosPagamento
      console.log('recursos_de_glosa/AnexosUploadDlg', data_pagamento, prestador_id, operadora_ans_id)
      let payload = {grupo_economico: this.grupoEconomico, id: item.id, data_pagamento, prestador_id, operadora_ans_id }
      payload.prestador_id = this.dadosPagamento.prestador_id
      let obj = {query: [{Modulo: "Recebiveis", Acao: "DeleteAnexoRecursoUpload", Payload: payload}]}
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        this.getArquivosAnexo(this.itemSelecionado)
      })
    },
    verificaExtensao(ind){   
      if(this.listaDeAnexos[ind].anexo != null || this.listaDeAnexos[ind].anexo != undefined){
        let exte = this.listaDeAnexos[ind].anexo.name.substring(this.listaDeAnexos[ind].anexo.name.lastIndexOf("."), this.listaDeAnexos[ind].anexo.name.length)
        this.listaDeAnexos[ind].exte = exte
      }
    },
    enviarArquivos() {
      let payload = {}
      if(this.emMassa){
        console.log(this.edicaoMassa)
        console.log(this.tipoConsulta)
        this.dadosEdicaoMassa = this.edicaoMassa[this.tipoConsulta].filter(el => el.selected==true || el.selected==false)
        let id = this.dadosEdicaoMassa.map(el => el.id)
        payload = {
          grupo_economico: this.grupoEconomico,
          obj_type: this.tipoConsulta,
          ...this.filterData,
          anexar_em_massa: true,
          selecionar_todos: this.selecionarTodos,
          id
        };
      } else {
        let { id, recurso_stage_id, recurso_lote_id, recurso_guia_id } = this.itemSelecionado
        payload = { 
          grupo_economico: this.grupoEconomico, 
          recurso_stage_id, 
          recurso_lote_id, 
          anexar_em_massa: false 
          };
        if(this.tipoConsulta == 'guias') {
          payload.recurso_guia_id = id;
        } else if(this.tipoConsulta == 'itens') {
          payload.recurso_guia_id = recurso_guia_id;
          payload.recurso_item_id = id;
        } else if (this.tipoConsulta == 'lotes') {
          payload.recurso_lote_id = id;
        }
      }
      payload.pagamento_id = this.dadosPagamento.id
      payload.operadora_ans_id = this.dadosPagamento.operadora_ans_id
      payload.prestador_id = this.dadosPagamento.prestador_id
      
      let datas = []
      
      this.listaDeAnexos.forEach((elemento) => {
        
        if((elemento.tipo != null || elemento.tipo != undefined) && (elemento.anexo != undefined || elemento.anexo != null)){
          let file = elemento.anexo
          payload.tipo = elemento.tipo
          payload.tipo_documento = elemento.tipo_documento
          payload.formato_documento = elemento.formato_documento
          payload.observacao = elemento.observacao
          let Payload = JSON.stringify(payload)

          let data = new FormData();
          data.append('Modulo', 'Recebiveis');
          data.append('Acao', 'addanexorecursoupload');
          data.append('Payload', Payload);
          data.append('File', file);
          
          datas.push(data)
        }
      })
      
      this.$store.dispatch("request/sendFiles", datas).then((response) => {
        this.resEnvio = response.sucesso
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader"); 
          
          let nomesFalha = response.listaResp.reduce((acc, va) => {
            if(!va.sucesso){
              acc.push(va.nome)
            }
            return acc
          }, [])
          
          this.listaDeAnexos = this.listaDeAnexos.reduce((arr, elemento) => {
            if( nomesFalha.findIndex(el => el == elemento.anexo.name) > -1){
              elemento.error = true
              arr.push(elemento)
            }
            return arr
          }, [])
          if(response.listaResp[0].mensagem === 'Contate o administrador do sistema'){
            
            let paramModal = {
              type: "error",
              title: response.listaResp[0].mensagem,
              message: 'Paramêtros não configurados',
              callback: () => { this.getArquivosAnexo(this.itemSelecionado) },
              btConfirm: { name: "Ok", show: true },
            }
        
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          }
          return;

        }
        
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: "Todos salvos com sucesso",
          callback: () => { this.emMassa? '': this.getArquivosAnexo(this.itemSelecionado), 
                            this.listaDeAnexos = [{ tipo: null, anexo: null, exte: '.pdf' 
                          }] },
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("hideLoader");
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
      
    },
    verificaRegras(){
      console.log('verificaRegras')
      let resTeste = []
      this.listaDeAnexos.forEach(item => {
        resTeste.push(this.parametrosAnexo.extensoes.filter(ele => ele.toLowerCase() == item.exte.toLowerCase()).length > 0 ? false : true)
        resTeste.push(item.anexo != null ? item.anexo.size / 1024 > this.parametrosAnexo.tamanho_maximo ? true : false : false)
        resTeste.push(item.anexo != null ? item.anexo.name.length > this.parametrosAnexo.max_nome_arquivo ? true : false : false)
        resTeste.push(item.anexo != null ? item.anexo.name.substring(0,item.anexo.name.lastIndexOf('.')).length > item.anexo.name.substring(0,item.anexo.name.lastIndexOf('.')).match(/[A-Za-z0-9._-\s]/gi).length ? true : false : false)
      })
      if(resTeste.indexOf(true) == -1){
        return false
      }
      return true
    },
    confirmEnviarArquivos(){
      if(this.$refs.anexos_tipo.validate()){
        this.enviarArquivos()
      } 
    }
  },
  props: {
    close: Function,
    dadosPagamento: Object,
    edicaoMassa: Object,
    dialog: Boolean,
    emMassa: Boolean,
    filterData: Object,
    getArquivosAnexo: Function,
    grupoEconomico: Number,
    itemSelecionado: Object,
    listaArquivos: Array,
    num_lote: String,
    parametros: Object,
    selecionarTodos: Boolean,
    tipoConsulta: String,
    total: Number
  },
};
</script>

<style>


</style>